module.exports = __webpack_public_path__ + "static/img/machine_l_bg.9d9a9dc4.jpg";